interface DataTableWrapperProps {
  children: JSX.Element;
}
export function DataTableWrapper({
  children
}: DataTableWrapperProps) {
  return <div className="relative border max-h-[750px] overflow-auto">
      {children}
    </div>;
}